import { createSelector } from '@reduxjs/toolkit';

import { AppStateType } from '@lib/core/service/types/appStateType';

export const selectBanners = (state: AppStateType) => state?.banners;

export const selectBannersData = createSelector([selectBanners], banners => banners.data);

export const selectIsBannersLoading = createSelector([selectBanners], banners => banners.isLoading);

export const selectBannersError = createSelector([selectBanners], banners => banners.error);

export const selectDiscountBanner = createSelector([selectBanners], banners => banners.discountBanner);

export const selectIsDiscountBannerShown = createSelector([selectBanners], banners => banners.isDiscountVoucherShown);
